import { useTranslation } from 'react-i18next';

import type { CourierPickupStatus, CourierPickupStatusGroup } from '@/api/types/pickups';
import { cn } from '@/lib/utils';

/** Figma-derived badge tints, one per colour-coding group. */
const GROUP_BG: Record<CourierPickupStatusGroup, string> = {
  created: 'bg-[#E7F3FF]',
  pending: 'bg-[#FFF5CC]',
  collected: 'bg-[#E8F5E9]',
  cancelled: 'bg-[#FDECEA]',
  exception: 'bg-[#FFE9D6]',
};

const badgeClasses =
  'inline-flex h-6 items-center justify-center gap-1 whitespace-nowrap rounded-[10px] px-2 text-sm font-medium leading-5 text-black';

export function PickupStatusBadge({
  status,
  group,
  className,
}: {
  status: CourierPickupStatus;
  group: CourierPickupStatusGroup;
  className?: string;
}) {
  const { t } = useTranslation('pickup-orders');

  return (
    <span className={cn(badgeClasses, GROUP_BG[group] ?? 'bg-[#F7F7F7]', className)}>
      {t(`statuses.${status}`, { defaultValue: status })}
    </span>
  );
}
